<script>
import {useStore} from "vuex";
import {computed, ref} from "vue";
import Swal from "sweetalert2";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import router from "@/router";
import {Haptics, ImpactStyle} from '@capacitor/haptics';
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

export default {
  name: "OrdersPage",
  components: {FooterPage, NavbarPage, LoadingPage},

  setup() {

    let store = useStore()

    let products = computed(()=>store.state.order.products)

    let type = ref()
    let unit_name = ref()
    let unit_id = ref(products.value[0]?.unit_id ?? 0)

    let loading = ref(false)

    let page = ref('orders')

    if (products.value.length > 0) {
      unit_name.value = products.value[0].name_store
      type.value = products.value[0].type
      products.value.forEach((item)=>{
        item.select_installer = 0
      })

      if (type.value !== "education") check_products()
    } else {
      window.history.back()
    }


    function check_products() {

      let products_id = []

      products.value.forEach((item) => {
        item.variable_id ? products_id.push({
          id: item.id,
          variable_id: item.variable_id
        }) : products_id.push({id: item.id, variable_id: ''})
      })

      FreeWorld.Heisenberg({products: products_id} , 'check_shopping_cart').then((result) => {

        let check_delete = false

        let res = result.data
        products.value.forEach((item) => {
          let found = item.is_variable > 0 ? res.checked.find(items => items.variable_id === item.variable_id) : res.checked.find(items => items.id === item.id)

          if (found) {
            item.price = found.price
            item.off_price = found.off_price
            if (item.order_count_select > found.count && item.count != -1) item.order_count_select = found.count
            store.commit('ProductUpdate', item)
          }
        })

        if (res.deleted.length > 0) {
          products.value.forEach((item) => {
            let found = item.is_variable > 0 ? res.deleted.find(items => items.variable_id === item.variable_id) : res.deleted.find(items => items.id === item.id)

            if (found) {
              item.order_count_select = 0
              store.commit('ProductUpdate', item)
              check_delete = true
            }
          })
        }

        if (check_delete) {
          Swal.fire({
            icon: 'warning',
            confirmButtonText: 'متوجه شدم',
            text: 'متاسفانه یک سری از محصولات شما از طرف فروشنده حذف شدند!',
            allowOutsideClick: false,
          })
        }

      }).catch((result) => {
        Swals.Catch(result , check_products , true)
      })
    }

    function UpdateProduct(index, action) {

      if (action === 'delete') {

        products.value[index].order_count_select = 0
        store.commit("ProductUpdate", products.value[index])

        if (products.value.length === 0) {
          history.back()
        }

      } else {

        if (products.value[index].order_count_select < 0 || !products.value[index].order_count_select) products.value[index].order_count_select = 0

        if (products.value[index].order_count_select === 0) {

          store.commit("ProductUpdate", products.value[index])

          if (products.value.length === 0) {
            history.back()
          }

        } else {
          store.commit('ProductUpdate', products.value[index])
        }


        if (products.value.length === 0) {
          history.back()
        }
      }
    }

    function closing_page() {

      Swal.fire({
        text: "آیا میخواهید سبد خرید را لغو کنید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#d33",
        confirmButtonText: "لغو میکنم",
        cancelButtonText: "منصرف شدم",
        showClass: {
          popup: 'animate__animated animate__bounceInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__bounceOutUp'
        }
      }).then((result) => {

        if (result.isConfirmed) {

          store.commit('EmptyBasket')

          Swal.fire({
            text: "سبد خرید شما لغو شد",
            icon: "success",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            router.push({name: 'HomePage'})
          })
        }

      })

    }

    function alerts(action) {

      if (action == 'End of inventory') {

        Haptics.impact({style: ImpactStyle.Light});
        Haptics.vibrate();

        Swal.fire({
          text: "موجودی محصول به اتمام رسید!",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })

      }

    }

    function change_page() {
      let data = ref({})

      if (type.value === 'product') {
        router.push({name: 'OrdersInformation'})
      }
      else {
        data.value.education_id = []
        data.value.type_order = 'education'
        data.value.long = null
        data.value.lat = null
        data.value.address_id = ''
        data.value.transport_id = ''
        data.value.transport_price = 0
        products.value.forEach((item) => {
          data.value.education_id.push({id: item.id})
        })
        data.value.final_price = products.value[0]?.off_price ?? products.value[0]?.price
        store.commit('set_information_orders', data.value)
        router.push({name: 'OrdersPayment'})
      }
    }


    return {
      UpdateProduct,
      store,
      products,
      unit_name,
      closing_page,
      alerts,
      type,
      page,
      loading,
      change_page,
      unit_id
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div :class="loading ? 'activeClass' : '' " dir="ltr" id="main" class="bg-main">

    <div class="div-top-arrow bg-color d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <img @click="closing_page" class="svg-arrow" src="../assets/img/closing.svg" alt="">
      </div>
      <div class="d-flex align-items-center">
        <p class="m-0">
          سبد خرید
        </p>
        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div v-if="products.length != 0" class="p-body mb-3 mt-2">
      <div class="animate__animated animate__fadeIn bg-white rounded-4 p-2">

        <div v-for="(item , index) in products" :key="index" class="">

          <div class="d-flex justify-content-between">
            <div style="width: calc(100% - 10.5rem)" class="d-flex flex-column justify-content-around">
              <div class="d-flex justify-content-between align-items-center">

                <div @click="UpdateProduct(index , 'delete')" class="">
                  <img style="width: 2rem" class="rounded-pill" src="../assets/img/closing_prod.svg" alt="">
                </div>

                <div class="overflow-hidden mx-2">
                  <p dir="rtl" class="font-4 font-bold text-end m-0 mx-2"
                     :class="item.name.length > 28 ? 'txtoverflow':''">{{ item.name }}</p>
                </div>
              </div>

              <div class="d-flex align-items-center"
                   :class="type === 'product' ? 'justify-content-between':'justify-content-end' ">

                <div style="height: 4rem" v-if="type === 'product'" class="w-40">
                  <div class="d-flex py-2 px-3 h-100 align-items-center rounded-pill justify-content-between border-costom">
                    <img style="width: 1rem" class="svg_inventory" src="../assets/img/minus.svg" alt=""
                         @click="item.order_count_select-- ;UpdateProduct(index)">

                    <input class="font-4 font-bold text-center w-100" @focusout="UpdateProduct(index)" v-model="item.order_count_select" type="number">


                    <img style="width: 1rem" class="svg_inventory" src="../assets/img/add_green.svg" alt=""
                         v-if="item.count == -1 "
                         @click="item.order_count_select++ ;UpdateProduct(index)">

                    <img style="width: 1rem" class="svg_inventory" src="../assets/img/add_green.svg" alt=""
                         @click="item.order_count_select++ ;UpdateProduct(index)"
                         v-else-if="item.order_count_select < item.count">

                    <img style="width: 1rem" class="svg_inventory" src="../assets/img/add_green.svg" alt=""
                         v-else
                         @click="alerts('End of inventory')">


                    <!--                  <img style="width: 25%" class="svg_inventory" src="../assets/img/add_green.svg" alt=""-->
                    <!--                       @click="item.order_count_select++; item.order_count_select < item.count ;UpdateProduct(item.id)">-->
                  </div>
                </div>


                <div class="d-flex align-items-end flex-column mx-2">
                  <p class="m-0 d-flex"
                     :class="item.off_price == null ? 'font-color font-4' : 'text-decoration-line-through font-5' ">
                    <span v-if="item.off_price == null ">تومان</span>
                    <span class="">{{ item.price.toLocaleString() }}</span>
                  </p>

                  <p v-if="item.off_price != null " :class="item.off_price != null ? 'font-color font-4' : 'font-5' "
                     class="m-0 d-flex ">
                    <span>تومان</span>
                    <span class="mx-1">{{ item.off_price.toLocaleString() }}</span>
                  </p>
                </div>

              </div>
            </div>

            <div class="img_prod rounded-4 animated-background">
              <img v-if="item.type === 'product' " class="w-100 h-100 rounded-4" :src="item.pic1" alt="">
              <img v-else class="w-100 h-100 rounded-4" :src="item.profile_pic" alt="">
            </div>
          </div>

          <div v-if="item.installer === 1"
               class="mt-2 d-flex align-items-center bg-white rounded-4 justify-content-between">

            <div v-ripple class="p-2 px-4 bg-costom rounded-pill">
              <p v-if="item.select_installer === 1" @click="item.select_installer = 0" class="m-0 font-5">بلی</p>

              <p v-else @click="item.select_installer = 1" class="m-0 font-5">خیر</p>
            </div>

            <div class="d-flex align-items-center">
              <p class="m-0 mx-2 font-5">
                برای این محصول احتیاج به نصاب دارید؟
              </p>
              <img style="width: 1.5rem" src="../assets/img/worker_icon.svg" alt="">
            </div>

          </div>

          <hr>

        </div>

        <router-link :to="{name:'StorePage' , params:{unit_id:unit_id}}" v-if="products.length != 0 && type == 'product' "
             class="animate__animated animate__fadeIn text-black text-decoration-none d-flex flex-row-reverse align-items-center">
          <img style="width: 1.5rem" src="../assets/img/shop.svg" alt="">
          <p class="font-4 m-0 mx-2">{{ unit_name }}</p>
        </router-link>

      </div>
    </div>

    <br><br><br><br>

    <div class="button_div w-100 d-flex justify-content-center p-body">
      <v-btn @click="change_page" class="w-100 h-75 mx-4 font-4 bg-color rounded-pill border-costom text-white my-2">
        تایید و ادامه سبد خرید
      </v-btn>
    </div>
  </div>

  <div :class="loading ? 'activeClass' : '' " id="web" class="bg-main">

    <NavbarPage></NavbarPage>
    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-3 w-75 ma-auto">سبد خرید</div>

    <div dir="ltr" class="w-75 ma-auto">
      <div v-if="products.length != 0" class="mb-3 mt-2">
        <div class="animate__animated animate__fadeIn bg-white rounded-4 p-2 overflow-hidden">

          <div v-for="(item , index) in products" :key="index" class="">

            <div class="d-flex justify-space-between flex-row-reverse">

              <div style="height: 10rem;width: 10rem" class="rounded-4 animated-background">
                <img v-if="item.type == 'product' " class="w-100 h-100 rounded-4" :src="item.pic1" alt="">
                <img v-else class="w-100 h-100 rounded-4" :src="item.profile_pic" alt="">
              </div>

              <div style="width: calc(100% - 10.5rem)" class="d-flex flex-column justify-content-around position-relative">
                <div @click="UpdateProduct(index , 'delete')" style="left: 0;top: 0" class="position-absolute">
                  <img style="width: 35px" class="rounded-pill"
                       src="../assets/img/closing_prod.svg" alt="">
                </div>

                <div class="">
                  <p dir="rtl" class="font-3 font-bold text-right m-0 mx-2">{{ item.name }}</p>
                </div>

                <br>

                <div class="d-flex align-items-center"
                     :class="type == 'product' ? 'justify-content-between':'justify-content-end' ">

                  <div v-if="type == 'product' "
                       class="w-25 d-flex py-2 px-3 rounded-pill justify-content-between border-costom">
                    <img style="width: 15px" class="svg_inventory" src="../assets/img/minus.svg" alt=""
                         @click="item.order_count_select-- ;UpdateProduct(index)">

                    <p class="m-0 font-4 font-bold">{{ item.order_count_select }}</p>


                    <img style="width: 15px" class="svg_inventory" src="../assets/img/add_green.svg" alt=""
                         v-if="item.count == -1 "
                         @click="item.order_count_select++ ;UpdateProduct(index)">

                    <img style="width: 15px" class="svg_inventory" src="../assets/img/add_green.svg" alt=""
                         @click="item.order_count_select++ ;UpdateProduct(index)"
                         v-else-if="item.order_count_select < item.count">

                    <img style="width: 15px" class="svg_inventory" src="../assets/img/add_green.svg" alt=""
                         v-else
                         @click="alerts('End of inventory')">


                    <!--                  <img style="width: 25%" class="svg_inventory" src="../assets/img/add_green.svg" alt=""-->
                    <!--                       @click="item.order_count_select++; item.order_count_select < item.count ;UpdateProduct(item.id)">-->
                  </div>

                  <div class="d-flex">
                    <p v-if="item.off_price != null " :class="item.off_price != null ? 'font-color font-3' : '' "
                       class="m-0 d-flex mr-10">
                      <span>تومان</span>
                      <span class="mx-1">{{ item.off_price.toLocaleString() }}</span>
                    </p>

                    <p class="m-0 d-flex"
                       :class="item.off_price == null ? 'font-color font-3' : 'text-decoration-line-through font-4' ">
                      <span v-if="item.off_price == null ">تومان</span>
                      <span class="">{{ item.price.toLocaleString() }}</span>
                    </p>
                  </div>

                </div>
              </div>
            </div>

            <div v-if="item.installer === 1" class="mt-2 d-flex align-items-center bg-white rounded-4 justify-content-between">

              <div v-ripple class="p-2 px-4 bg-costom rounded-pill">
                <p v-if="item.select_installer === 1" @click="item.select_installer = 0" class="m-0 font-5">بلی</p>

                <p v-else @click="item.select_installer = 1" class="m-0 font-5">خیر</p>
              </div>

              <div class="d-flex align-items-center">
                <p class="m-0 mx-2 font-5">
                  برای این محصول احتیاج به نصاب دارید؟
                </p>
                <img style="width: 20px" src="../assets/img/worker_icon.svg" alt="">
              </div>

            </div>

            <hr>
          </div>

          <router-link :to="{name:'StorePage' , params:{unit_id:unit_id}}" v-if="products.length != 0 && type == 'product' "
               class="animate__animated animate__fadeIn text-decoration-none text-black py-2 d-flex flex-row-reverse align-items-center">
            <img style="width: 20px" src="../assets/img/shop.svg" alt="">
            <p class="font-3 m-0 mx-2">{{ unit_name }}</p>
          </router-link>

        </div>
      </div>

      <br>
      <br>
      <br>
      <br>
      <div style="height: 80px" class="w-100 d-flex justify-content-center p-body">
        <v-btn @click="change_page" class="w-50 h-75 mx-4 bg-color rounded-pill border-costom text-white my-2">
          تایید و ادامه سبد خرید
        </v-btn>
      </div>
    </div>

    <FooterPage></FooterPage>
  </div>

</template>

<style scoped>

.w_products_add {
  width: 20px;
}

.button_div {
  height: 80px;
  position: fixed;
  bottom: 0;
  max-width: 700px;
}

.img_prod {
  height: 11rem;
  width: 11rem;
}
</style>